export const text = {
  FIRST_NAME: 'First name:',
  PREFERRED_NAME: 'Preferred name:',
  LAST_NAME: 'Last name:',
  DOB: 'DOB:',
  DOB_WITH_FORMAT: 'DOB (MM/DD/YYYY)',
  PERSONAL: 'Personal',
  EMERGENCY_CONTACT: 'Emergency contact',
  RELATIONSHIP_TO_PATIENT: 'Relationship to patient:',
  PHONE: 'Phone:',
  CONTACT: 'Contact',
  EMAIL: 'Email:',
  STREET_ADDRESS: 'Street address:',
  PREFERRED_PHARMACY: 'Preferred pharmacy:',
  COMPLETED_ON: 'Completed on:',
  VISIT_TYPE: 'Visit type:',
  LAST_UPDATE: 'Last updated:',
  BODY_MEASUREMENTS: 'Body measurements',
  HEIGHT: 'Height:',
  WEIGHT: 'Weight:',
  IDENTITY: 'Identity',
  MARITAL_STATUS: 'Marital status:',
  SEX_AT_BIRTH: 'Sex at birth:',
  GENDER_IDENTITY: 'Gender identity:',
  RACIAL_BACKGROUND: 'Racial background:',
  ACCOUNT_INFORMATION: 'Account information',
  PRESCRIPTIONS: 'Orders',
  PAST_VISITS: 'Past visits',
  GENERAL_INFORMATION: 'General information',
  NO_PAST_VISITS: 'No past visits',
  PATIENT: 'Patient:',
  EDIT: 'Edit',
  SAVE: 'Save',
  HEIGHT_FT: 'height (ft)',
  INTAKE_FORMS: 'Intake forms',
  MARITAL_STATUS_LOWER: 'marital status',
  RACIAL_BACKGROUND_LOWER: 'racial background',
  GENDER_IDENTITY_LOWER: 'gender identity',
  PHONE_NUMBER: 'phone number',
  DIVIDER: 'Divider',
  UNAVAILABLE: 'timezone unavailable',
}
